<template>


<section class="kc-elm kc-css-532656 kc_row">
   <div class="befbgr" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="befbgr" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="aftbgr" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="aftbgr" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="befbgr5" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="befbgr6" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="aftbgr7" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="aftbgr8" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="kc-row-container">
      <div class="kc-wrap-columns">
         <div class="kc-elm kc-css-615932 kc_col-sm-12 kc_column kc_col-sm-12">
            <div class="kc-col-container">
               <div class="kc-elm kc-css-792323 kc_row kc_row_inner sst-flex-row-inner">
                  <div class="kc-elm kc-css-260313 kc_col-sm-6 kc_column_inner kc_col-sm-6">
                     <div class="kc_wrapper kc-col-inner-container">
                        <div class="ssc_mltttl  kc-elm kc-css-222140 ">
                           <h2 class="wr deb derb dea dera none nonea"></h2>
                           <h2 class="t1">Testimonials</h2>
                           <div class="t3"> </div>
                        </div>
                        <div class="ssc_mltttl  kc-elm kc-css-636088 ">
                           <h3 class="wr deb derb dea dera none nonea">
                              <span class="t1">What our Customers are Saying</span>
                              <div class="t3"> </div>
                           </h3>
                        </div>
                        <div class="ssc_carousel template-1 kc-elm kc-css-317635 kc_tabs group kc-tabs-slider">
                           <div class="owl-carousel owl-theme" style="opacity: 1; display: block;">
                              <div class="owl-wrapper-outer">
                                 <div class="owl-wrapper" style="width: 3660px; left: 0px; display: block;">
                                    <div class="owl-item" style="width: 610px;">
                                       <div id="new-tab" class="kc-elm kc-css-639196 kc_tab ui-tabs-panel kc_ui-tabs-hide kc_clearfix ">
                                          <div class="kc_tab_content">
                                             <div class="ssc_testi type6 mo none  kc-elm kc-css-44971">
                                                <figure><img class=" ls-is-cached lazyloaded" data-src="../../assets/images/test_img.png" alt="Tim Brown Aora Company" style="-webkit-filter: grayscale(0);filter: grayscale(0);" src="../../assets/images/test_img.png"></figure>
                                                <h5 class="title">Tim Brown</h5>
                                                <div class="position">Aora Company</div>
                                                <div class="desc">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor inidunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute </div>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                    <div class="owl-item" style="width: 610px;">
                                       <div id="new-tab2" class="kc-elm kc-css-119757 kc_tab ui-tabs-panel kc_ui-tabs-hide kc_clearfix ">
                                          <div class="kc_tab_content">
                                             <div class="ssc_testi type6 mo none  kc-elm kc-css-619440">
                                                <figure><img class=" ls-is-cached lazyloaded" data-src="../../assets/images/test_img.png" alt="Tim Brown Aora Company" style="-webkit-filter: grayscale(0);filter: grayscale(0);" src="../../assets/images/test_img.png"></figure>
                                                <h5 class="title">Tim Brown</h5>
                                                <div class="position">Aora Company</div>
                                                <div class="desc">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor inidunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute </div>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                    <div class="owl-item" style="width: 610px;">
                                       <div id="new-tab3" class="kc-elm kc-css-551971 kc_tab ui-tabs-panel kc_ui-tabs-hide kc_clearfix ">
                                          <div class="kc_tab_content">
                                             <div class="ssc_testi type6 mo none  kc-elm kc-css-599946">
                                                <figure><img class=" ls-is-cached lazyloaded" data-src="../../assets/images/test_img.png" alt="Tim Brown Aora Company" style="-webkit-filter: grayscale(0);filter: grayscale(0);" src="../../assets/images/test_img.png"></figure>
                                                <h5 class="title">Tim Brown</h5>
                                                <div class="position">Aora Company</div>
                                                <div class="desc">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor inidunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute </div>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                              <div class="owl-controls clickable">
                                 <div class="owl-pagination">
                                    <div class="owl-page active"><span class=""></span></div>
                                    <div class="owl-page"><span class=""></span></div>
                                    <div class="owl-page"><span class=""></span></div>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div class="bgrlabel  kc-elm kc-css-80702" style="bottom:-150px;right:-320px;">
                           <div class="inside_wrap">
                              <div class="imgl"><img class=" lazyloaded" data-src="../../assets/images/Skull.png" alt="" src="../../assets/images/Skull.png"></div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div class="kc-elm kc-css-757972 kc_col-sm-6 kc_column_inner kc_col-sm-6">
                     <div class="kc_wrapper kc-col-inner-container">
                        <div class="ssc_mltttl  kc-elm kc-css-958260 ">
                           <h2 class="wr deb derb dea dera none nonea"><span class="t1">What makes us  </span><span class="t2"> different</span></h2>
                        </div>
                        <div class="ssc_icon_box kc-elm kc-css-624171 template1 ">
                           <div class="icon_box">
                              <div class="bgr_no" style="width:35px; height:35px;">
                                 <div> </div>
                              </div>
                              <div class="c_img" style="margin-top: -35px; line-height:35px; height:35px; width:35px;"><img class=" ls-is-cached lazyloaded" data-src="../../assets/images/what_big.png" alt="Big experience" style="max-width: 30px; max-height: 30px;margin-top: calc((35px - 30px)/2);" src="../../assets/images/what_big.png"></div>
                           </div>
                           <div class="cont_box">
                              <div class="title">Big experience</div>
                              <div class="description lines0">
                                 <p>Many years of work in this field is an excellent indicator that companies trust us and in response we offer unique solutions for their business.</p>
                              </div>
                           </div>
                        </div>
                        <div class="ssc_icon_box kc-elm kc-css-941434 template1 ">
                           <div class="icon_box">
                              <div class="bgr_no" style="width:35px; height:35px;">
                                 <div> </div>
                              </div>
                              <div class="c_img" style="margin-top: -35px; line-height:35px; height:35px; width:35px;"><img class=" ls-is-cached lazyloaded" data-src="../../assets/images/what_strong.png" alt="Strong team" style="max-width: 30px; max-height: 30px;margin-top: calc((35px - 30px)/2);" src="../../assets/images/what_strong.png"></div>
                           </div>
                           <div class="cont_box">
                              <div class="title">Strong team</div>
                              <div class="description lines0">
                                 <p>An excellent team of professionals will help you to bring all your ideas to life in the best possible way and with flexible functionality.</p>
                              </div>
                           </div>
                        </div>
                        <div class="ssc_icon_box kc-elm kc-css-499767 template1 ">
                           <div class="icon_box">
                              <div class="bgr_no" style="width:35px; height:35px;">
                                 <div> </div>
                              </div>
                              <div class="c_img" style="margin-top: -35px; line-height:35px; height:35px; width:35px;"><img class=" lazyloaded" data-src="../../assets/images/what_diff.png" alt="Personal solutions" style="max-width: 30px; max-height: 30px;margin-top: calc((35px - 30px)/2);" src="../../assets/images/what_diff.png"></div>
                           </div>
                           <div class="cont_box">
                              <div class="title">Personal solutions</div>
                              <div class="description lines0">
                                 <p>Individual approach to your project. flexible solutions for your tasks to achieve your goals on the path to success.</p>
                              </div>
                           </div>
                        </div>
                        <div class="bgrlabel  kc-elm kc-css-687559" style="bottom:-100px;right:0px;">
                           <div class="inside_wrap">
                              <div class="imgl"><img class=" lazyloaded" data-src="../../assets/images/Pencils.png" alt="" src="../../assets/images/Pencils.png"></div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</section>


</template>

<script>
export default {
  name: "Testimonials",
  props: ["title", "subtitle", "header"],
  data() {
    return {
      msg: "Testimonials"
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media all{
*,.kc-col-container,.kc-elm{box-sizing:border-box;}
div{display:block;}
.kc-elm{float:left;width:100%;}
.kc_col-sm-6{width:50%;}
.kc_col-sm-12{width:100%;}
.kc-row-container:not(.kc-container){padding-left:0;padding-right:0;width:100%;max-width:100%;}
.kc_row:not(.kc_row_inner){clear:both;float:left;width:100%;}
.kc_row_inner{margin-left:-15px;margin-right:-15px;clear:both;}
.kc_row.kc_row_inner{width:calc(100% + 30px);}
.kc_column,.kc_column_inner{min-height:1px;position:relative;padding-right:15px;padding-left:15px;float:left;}
.kc_column>.kc-col-container,.kc_column_inner>.kc-col-inner-container{height:100%;}
.kingcomposer div.kc_column,.kingcomposer div.kc_column_inner{clear:none;}
.kc-col-container{clear:both;display:block;width:100%;}
@media screen and (min-width:999px){
.kc-row-container .kc-wrap-columns,.kc_row_inner{display:-webkit-flex;display:-ms-flexbox;display:flex;width:100%;flex-wrap:wrap;}
.kc_row_inner{width:calc(100% + 30px);}
}
@media screen and (max-width:767px){
body.kc-css-system .kc_column,body.kc-css-system .kc_column_inner{width:100%;}
div.kc_row{display:block;}
}
.kc_tabs{margin-bottom:24px;}
.kc_tabs{display:inline-block;width:100%;}
*{box-sizing:border-box;}
*:before,*:after{box-sizing:border-box;}
div:focus{outline:none;}
figure,section{display:block;}
img{border:0;max-width:100%;}
figure{margin:0 auto;}
h2{font-family:"Montserrat";color:#222;font-weight:500;font-size:40px;line-height:52px;text-transform:full-size-kana;text-align:left;margin:20px 0 15px 0;}
h3{font-family:"Catamaran";color:#222;font-weight:500;font-size:25px;line-height:32px;text-align:left;margin:20px 0;}
h5{font-family:"Montserrat";color:#222;font-weight:700;font-size:25px;line-height:40px;text-transform:full-size-kana;text-align:center;margin:20px 0 10px 0;}
h5{font-size:22px;line-height:32px;}
p{margin:10px 0 25px 0;}
.page p{line-height:29px;}
*,*:before,*:after{box-sizing:inherit;}
.kc_row.kc_row_inner:focus{outline:none;}
img{height:auto;max-width:100%;}
.kc-row-container:after{content:"";display:block;clear:both;}
body .kc_tab_content:after{content:"";display:block;clear:both;}
.owl-theme .owl-controls{margin-top:20px;text-align:center;}
.owl-theme .owl-controls .owl-page{display:inline-block;zoom:1;*display:inline;}
.owl-theme .owl-controls .owl-page span{display:block;width:8px;height:8px;margin:5px 3px;filter:Alpha(Opacity=30);opacity:.3;-webkit-border-radius:20px;-moz-border-radius:20px;border-radius:20px;background:#272727;}
.owl-theme .owl-controls .owl-page.active span,.owl-theme .owl-controls.clickable .owl-page:hover span{filter:Alpha(Opacity=100);opacity:1;}
.owl-carousel .owl-wrapper:after{content:".";display:block;clear:both;visibility:hidden;line-height:0;height:0;}
.owl-carousel{display:none;position:relative;width:100%;-ms-touch-action:pan-y;}
.owl-carousel .owl-wrapper{display:none;position:relative;-webkit-transform:translate3d(0,0,0);}
.owl-carousel .owl-wrapper-outer{overflow:hidden;position:relative;width:100%;}
.owl-carousel .owl-item{float:left;}
.owl-controls .owl-page{cursor:pointer;}
.owl-controls{-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-tap-highlight-color:rgba(0,0,0,0);}
.owl-carousel .owl-wrapper,.owl-carousel .owl-item{-webkit-backface-visibility:hidden;-moz-backface-visibility:hidden;-ms-backface-visibility:hidden;-webkit-transform:translate3d(0,0,0);-moz-transform:translate3d(0,0,0);-ms-transform:translate3d(0,0,0);}
body .owl-theme .owl-controls .owl-page.active span,.owl-theme .owl-controls.clickable .owl-page:hover span{transform:scale(1.3);}
.owl-theme .owl-controls .owl-page span{transition:all 0.3s;}
.kc-col-container>div{position:relative;}
@media screen and (max-width:601px){
h2{font-family:"Montserrat";color:#222;font-weight:500;font-size:30px;line-height:34px;text-transform:none;text-align:center;}
p{margin:10px 0 25px 0;line-height:26px;}
h2{font-family:"Montserrat";color:#222;font-weight:500;font-size:30px;line-height:34px;text-transform:none;text-align:center;margin:20px 0;}
}
body .bgrlabel{float:none;position:absolute;display:inline-block;width:auto;}
section{position:relative;}
.befbgr,.befbgr5,.befbgr6{position:absolute;top:0;left:0;width:100%;line-height:0;transition:all 300ms;}
.aftbgr,.aftbgr7,.aftbgr8{position:absolute;bottom:0;left:0;width:100%;line-height:0;transition:all 300ms;}
.ssc_icon_box.kc-elm{margin-bottom:10px;width:auto;}
.ssc_icon_box:after{content:"";display:block;clear:both;}
.ssc_icon_box,.ssc_icon_box .bgr_no,.ssc_icon_box .c_img,.ssc_icon_box .c_img img,.ssc_icon_box .icon_box,.ssc_icon_box .cont_box,.ssc_icon_box .title,.ssc_icon_box .cont_box .description{transition:all 350ms ease-in;}
.ssc_icon_box.template1{display:table;}
.ssc_icon_box.template1>div{display:table-cell;}
.ssc_icon_box.template1 .cont_box{padding-left:30px;}
.ssc_icon_box .bgr_no{position:relative;z-index:1;display:block;}
.ssc_icon_box .bgr_no div{display:block;}
.ssc_icon_box .c_img{position:relative;z-index:9;text-align:center;margin-left:auto;margin-right:auto;}
.ssc_icon_box .c_img img{margin-top:calc((90px - 40px)/2);}
.ssc_icon_box .icon_box{width:10px;}
.ssc_icon_box .cont_box{vertical-align:top;}
.ssc_icon_box .title{margin-bottom:2px;font-size:20px;font-weight:700;}
.ssc_icon_box .cont_box .description{line-height:1.4em;}
.ssc_icon_box .cont_box .description p:first-child{margin-top:0;}
.ssc_icon_box .cont_box .description p:last-child{margin-bottom:0;}
.main [class*="lines"]{display:-webkit-box!important;-webkit-box-orient:vertical;overflow:hidden;}
@media screen and (max-width:1024px){
.befbgr,.befbgr5,.befbgr6,.aftbgr,.aftbgr7,.aftbgr8{overflow:hidden;}
}
@media screen and (max-width:480px){
.ssc_icon_box .c_img,.ssc_icon_box .bgr_no{margin-left:auto;margin-right:auto;}
.ssc_icon_box .icon_box{text-align:center;}
.ssc_icon_box.template1 .cont_box{padding-left:15px;}
}
.ssc_mltttl>h2,.ssc_mltttl>h3{display:inline-block;width:auto;position:relative;}
.ssc_mltttl>div{display:block;width:auto;position:relative;}
body .owl-carousel:after{content:"";clear:both;display:block;}
.ssc_carousel .owl-theme .owl-controls{margin-top:0;}
.ssc_carousel .owl-theme .owl-controls{position:relative;z-index:3;}
.ssc_testi{transition:all 200ms;}
.deb:before,.dea:after{position:absolute;content:'';display:block;top:0;transition:all 400ms;}
.deb.none:before,.dea.nonea:after{content:none;}
.derb:before,.dera:after{right:0;}
.owl-item:hover{z-index:5;}
.kc-col-container:after{content:"";display:block;clear:both;}
.sst-flex-row-inner{position:relative;z-index:1;min-height:30px;}
}
/*! CSS Used from: Embedded */
@media (max-width: 479px){
h2{font-size:30px;line-height:34px!important;}
}
/*! CSS Used from: Embedded */
@media only screen and (min-width:1000px) and (max-width:5000px){
body.kc-css-system .kc-css-615932{width:100%;}
body.kc-css-system .kc-css-260313{width:50%;}
body.kc-css-system .kc-css-757972{width:50%;}
}
body.kc-css-system .kc-css-532656{padding-top:50px;padding-bottom:100px;}
body.kc-css-system .kc-css-260313{background:#222324 url(../../assets/images/whys-Outer.jpg) left center/cover repeat scroll;padding:130px 9% 130px 9%;}
body.kc-css-system .kc-css-222140{display:inline-block;}
body.kc-css-system .kc-css-222140 .deb:before{border-radius:50px 50px 50px 50px;width:40px;height:40px;}
body.kc-css-system .kc-css-222140 .deb:after{border-radius:20px 20px 20px 20px;width:8px;height:8px;margin-top:17px;margin-right:-4px;}
body.kc-css-system .kc-css-222140 .t1{color:#ffffff;}
body.kc-css-system .kc-css-222140 .t3{color:#ffffff;}
body.kc-css-system .kc-css-636088{display:inline-block;}
body.kc-css-system .kc-css-636088 .deb:before{border-radius:50px 50px 50px 50px;width:40px;height:40px;}
body.kc-css-system .kc-css-636088 .deb:after{border-radius:20px 20px 20px 20px;width:8px;height:8px;margin-top:17px;margin-right:-4px;}
body.kc-css-system .kc-css-636088 .t1{color:#ffffff;}
body.kc-css-system .kc-css-636088 .t3{color:#ffffff;}
body.kc-css-system .kc-css-317635{padding-top:45px;}
body.kc-css-system .kc-css-317635 .owl-pagination{text-align:left;margin-top:20px;}
body.kc-css-system .kc-css-317635 .owl-page span{background-color:#ffffff;}
body.kc-css-system .kc-css-44971.ssc_testi .title{color:#ffffff;font-size:17px;line-height:30px;font-weight:500;font-family:Catamaran;text-transform:uppercase;text-align:left;float:left;}
body.kc-css-system .kc-css-44971.ssc_testi .position{color:#dddddd;font-size:14px;line-height:24px;font-weight:400;font-family:Catamaran;float:left;padding-top:25px;padding-left:35px;}
body.kc-css-system .kc-css-44971.ssc_testi .desc{color:#ffffff;font-size:17px;line-height:1.765em;font-weight:400;font-family:Catamaran;float:right;}
body.kc-css-system .kc-css-619440.ssc_testi .title{color:#ffffff;font-size:17px;line-height:30px;font-weight:500;font-family:Catamaran;text-transform:uppercase;text-align:left;float:left;}
body.kc-css-system .kc-css-619440.ssc_testi .position{color:#dddddd;font-size:14px;line-height:24px;font-weight:400;font-family:Catamaran;float:left;padding-top:25px;padding-left:35px;}
body.kc-css-system .kc-css-619440.ssc_testi .desc{color:#ffffff;font-size:17px;line-height:1.765em;font-weight:400;font-family:Catamaran;float:right;}
body.kc-css-system .kc-css-599946.ssc_testi .title{color:#ffffff;font-size:17px;line-height:30px;font-weight:500;font-family:Catamaran;text-transform:uppercase;text-align:left;float:left;}
body.kc-css-system .kc-css-599946.ssc_testi .position{color:#dddddd;font-size:14px;line-height:24px;font-weight:400;font-family:Catamaran;float:left;padding-top:25px;padding-left:35px;}
body.kc-css-system .kc-css-599946.ssc_testi .desc{color:#ffffff;font-size:17px;line-height:1.765em;font-weight:400;font-family:Catamaran;float:right;}
body.kc-css-system .kc-css-757972{padding:130px 9% 130px 9%;}
body.kc-css-system .kc-css-958260.ssc_mltttl .wr{text-align:left;}
body.kc-css-system .kc-css-958260{text-align:left;padding-bottom:50px;display:inline-block;}
body.kc-css-system .kc-css-958260 .deb:before{border-radius:50px 50px 50px 50px;width:40px;height:40px;}
body.kc-css-system .kc-css-958260 .deb:after{border-radius:20px 20px 20px 20px;width:8px;height:8px;margin-top:17px;margin-right:-4px;}
body.kc-css-system .kc-css-958260 .t1{padding-right:15px;display:inline-block;}
body.kc-css-system .kc-css-958260 .t2{color:#ED7D31;display:inline-block;}
body.kc-css-system .kc-css-624171 .c_img img{margin-top:0px;}
body.kc-css-system .kc-css-624171 .c_img{padding-top:10px;padding-right:5px;}
body.kc-css-system .kc-css-624171 .bgr_no{text-align:center;}
body.kc-css-system .kc-css-624171 .title{color:#222222;font-size:20px;line-height:40px;font-weight:700;text-transform:none;}
body.kc-css-system .kc-css-624171 .cont_box .description{color:#666666;font-size:17px;margin-bottom:15px;}
body.kc-css-system .kc-css-624171 .cont_box .description,body.kc-css-system .kc-css-624171 .cont_box .description p{line-height:1.765em;}
body.kc-css-system .kc-css-941434 .c_img img{margin-top:0px;}
body.kc-css-system .kc-css-941434 .c_img{padding-top:10px;padding-right:5px;}
body.kc-css-system .kc-css-941434 .bgr_no{text-align:center;}
body.kc-css-system .kc-css-941434 .title{color:#222222;font-size:20px;line-height:40px;font-weight:700;text-transform:none;}
body.kc-css-system .kc-css-941434 .cont_box .description{color:#666666;font-size:17px;margin-bottom:15px;}
body.kc-css-system .kc-css-941434 .cont_box .description,body.kc-css-system .kc-css-941434 .cont_box .description p{line-height:1.765em;}
body.kc-css-system .kc-css-499767 .c_img img{margin-top:0px;}
body.kc-css-system .kc-css-499767 .c_img{padding-top:10px;padding-right:5px;}
body.kc-css-system .kc-css-499767 .bgr_no{text-align:center;}
body.kc-css-system .kc-css-499767 .title{color:#222222;font-size:20px;line-height:40px;font-weight:700;text-transform:none;}
body.kc-css-system .kc-css-499767 .cont_box .description{color:#666666;font-size:17px;margin-bottom:15px;}
body.kc-css-system .kc-css-499767 .cont_box .description,body.kc-css-system .kc-css-499767 .cont_box .description p{line-height:1.765em;}
@media only screen and (max-width:1024px){
body.kc-css-system .kc-css-532656{padding-bottom:60px;}
body.kc-css-system .kc-css-260313{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-80702{display:none;}
body.kc-css-system .kc-css-757972{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-687559{display:none;}
}
@media only screen and (max-width:767px){
body.kc-css-system .kc-css-532656{margin-top:60px;}
body.kc-css-system .kc-css-260313{padding-right:15px;padding-left:15px;}
body.kc-css-system .kc-css-757972{padding-right:15px;padding-left:15px;}
}
@media only screen and (max-width:479px){
body.kc-css-system .kc-css-757972{padding-top:30px;padding-bottom:0px;}
body.kc-css-system .kc-css-958260{margin-left:0px;}
}
</style>



// WEBPACK FOOTER //
// src/components/Blocks/Testimonials.vue